import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { useIsMobileScreen } from '~/hooks'

export type ContentProps = {
  title: string,
  description: string | JSX.Element
}

const useStyles = makeStyles({
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    [mutualTheme.breakpoints.down('md')]: {
      padding: mutualTheme.spacing(1)
    }
  },
  title: {
    fontWeight: 700,
    marginBottom: mutualTheme.spacing(2),
    color: mutualTheme.palette.mutualBlue.main
  },
  description: {
    marginBottom: mutualTheme.spacing(5),
    [mutualTheme.breakpoints.down('lg')]: {
      marginBottom: mutualTheme.spacing(3)
    }
  },
  childrenContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: mutualTheme.spacing(1),
    [mutualTheme.breakpoints.down('lg')]: {
      width: '100%'
    }
  }
})

export const Content: React.FC<ContentProps> = (props) => {
  const { title, description, children } = props
  const classes = useStyles()
  const isMobile = useIsMobileScreen()

  return (
    <Box className={classes.container}>
      <Typography variant='h1' className={classes.title}>
        {title}
      </Typography>
      <Typography variant={isMobile ? 'body2' : 'body1'} className={classes.description}>
        {description}
      </Typography>
      <Box className={classes.childrenContainer}>
        {children}
      </Box>
    </Box>
  )
}
